import {
  lucideAlignLeft,
  lucideLayers,
  lucideCircleDollarSign,
  lucideShirt,
  lucideShieldCheck,
  lucidePalette,
  lucideFile,
  lucideLock,
  lucideMinus,
  lucideActivity,
  lucideArrowLeftRight,
  lucideArrowUp,
  lucideBell,
  lucideBook,
  lucideBot,
  lucideBox,
  lucideCalendar,
  lucideCalendarX,
  lucideChartBar,
  lucideChartLine,
  lucideCheck,
  lucideChevronDown,
  lucideChevronLeft,
  lucideChevronRight,
  lucideChevronUp,
  lucideCircleCheck,
  lucideCircleHelp,
  lucideCircleX,
  lucideClock,
  lucideClipboardCopy,
  lucideClipboardPaste,
  lucideCopy,
  lucideCreditCard,
  lucideDatabase,
  lucideDownload,
  lucideEllipsis,
  lucideEllipsisVertical,
  lucideExternalLink,
  lucideFactory,
  lucideEye,
  lucideFilter,
  lucideFolder,
  lucideGlobe,
  lucideHeadphones,
  lucideKeyRound,
  lucideHistory,
  lucideHouse,
  lucideImages,
  lucideInfo,
  lucideLightbulb,
  lucideList,
  lucideLoaderCircle,
  lucideLogOut,
  lucideLayoutGrid,
  lucideMegaphone,
  lucideMessageSquare,
  lucideMonitor,
  lucideMoon,
  lucideMove,
  lucidePackage,
  lucidePanelLeft,
  lucidePause,
  lucidePencil,
  lucidePercent,
  lucidePin,
  lucidePlay,
  lucidePlus,
  lucideRefreshCw,
  lucideSave,
  lucideSearch,
  lucideSend,
  lucideSettings,
  lucideShield,
  lucideShoppingBag,
  lucideSparkles,
  lucideSquarePen,
  lucideStar,
  lucideSun,
  lucideTag,
  lucideTrash2,
  lucideTrendingUp,
  lucideTriangleAlert,
  lucideUsers,
  lucideWallet,
  lucideX,
  lucideZap,
  lucideZoomIn,
  lucideZoomOut,
  lucideArrowRight,
  lucideArrowUpDown,
  lucideBellRing,
  lucideCheckCheck,
  lucideCircleAlert,
  lucideEyeOff,
  lucideFlaskConical,
  lucideHourglass,
  lucideInbox,
  lucideLibrary,
  lucideListFilter,
  lucideMail,
  lucideMessageCircle,
  lucideMessageCircleQuestion,
  lucideRepeat,
  lucideSlidersHorizontal,
  lucideThumbsDown,
  lucideThumbsUp,
  lucideUserMinus,
  lucideUserPlus,
} from '@ng-icons/lucide';

/**
 * Ícones do app (migração primeicons → lucide, tabela em
 * JIRA/upgrade-angular/03-matriz-primeng-spartan.md).
 *
 * Registrados GLOBALMENTE no app.config via `provideIcons(APP_ICONS)` —
 * componentes só importam `NgIcon` e usam `<ng-icon name="lucidePlus" />`.
 *
 * De-para dos casos não óbvios:
 *  pi-times → lucideX · pi-cog → lucideSettings · pi-home → lucideHouse
 *  pi-th-large → lucideLayoutGrid · pi-bolt → lucideZap · pi-desktop → lucideMonitor
 *  pi-arrows-alt → lucideMove · pi-spinner → lucideLoaderCircle (+ animate-spin)
 *  pi-angle-right → lucideChevronRight · pi-star-fill → lucideStar (+ fill-current)
 *  pi-exclamation-triangle → lucideTriangleAlert · pi-question-circle → lucideCircleHelp
 */
export const APP_ICONS = {
  lucideAlignLeft,
  lucideLayers,
  lucideCircleDollarSign,
  lucideShirt,
  lucideShieldCheck,
  lucidePalette,
  lucideFile,
  lucideLock,
  lucideMinus,
  lucideActivity,
  lucideArrowLeftRight,
  lucideArrowUp,
  lucideBell,
  lucideBook,
  lucideBot,
  lucideBox,
  lucideCalendar,
  lucideCalendarX,
  lucideChartBar,
  lucideChartLine,
  lucideCheck,
  lucideChevronDown,
  lucideChevronLeft,
  lucideChevronRight,
  lucideChevronUp,
  lucideCircleCheck,
  lucideCircleHelp,
  lucideCircleX,
  lucideClock,
  lucideClipboardCopy,
  lucideClipboardPaste,
  lucideCopy,
  lucideCreditCard,
  lucideDatabase,
  lucideDownload,
  lucideEllipsis,
  lucideEllipsisVertical,
  lucideExternalLink,
  lucideFactory,
  lucideEye,
  lucideFilter,
  lucideFolder,
  lucideGlobe,
  lucideHeadphones,
  lucideKeyRound,
  lucideHistory,
  lucideHouse,
  lucideImages,
  lucideInfo,
  lucideLightbulb,
  lucideList,
  lucideLoaderCircle,
  lucideLogOut,
  lucideLayoutGrid,
  lucideMegaphone,
  lucideMessageSquare,
  lucideMonitor,
  lucideMoon,
  lucideMove,
  lucidePackage,
  lucidePanelLeft,
  lucidePause,
  lucidePencil,
  lucidePercent,
  lucidePin,
  lucidePlay,
  lucidePlus,
  lucideRefreshCw,
  lucideSave,
  lucideSearch,
  lucideSend,
  lucideSettings,
  lucideShield,
  lucideShoppingBag,
  lucideSparkles,
  lucideSquarePen,
  lucideStar,
  lucideSun,
  lucideTag,
  lucideTrash2,
  lucideTrendingUp,
  lucideTriangleAlert,
  lucideUsers,
  lucideWallet,
  lucideX,
  lucideZap,
  lucideZoomIn,
  lucideZoomOut,
  lucideArrowRight,
  lucideArrowUpDown,
  lucideBellRing,
  lucideCheckCheck,
  lucideCircleAlert,
  lucideEyeOff,
  lucideFlaskConical,
  lucideHourglass,
  lucideInbox,
  lucideLibrary,
  lucideListFilter,
  lucideMail,
  lucideMessageCircle,
  lucideMessageCircleQuestion,
  lucideRepeat,
  lucideSlidersHorizontal,
  lucideThumbsDown,
  lucideThumbsUp,
  lucideUserMinus,
  lucideUserPlus,
} as const;
